import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import defaultStyles from "./PriceDisplay.module.scss";

export const FixedPriceText = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const styles = useUiStyles(CoreUiComponents.PriceDisplay, defaultStyles);
  const [, cn] = useModuleBEM(styles, CoreUiComponents.PriceDisplay);

  return <span className={cn("fixed-price")}>{children}</span>;
};

export const FixedRewardsText = ({
  children,
  inline = "none",
}: {
  children: React.ReactNode;
  inline?: "all" | "priceOnly" | "none";
}) => {
  const styles = useUiStyles(CoreUiComponents.PriceDisplay, defaultStyles);
  const [, cn] = useModuleBEM(styles, CoreUiComponents.PriceDisplay);

  return (
    <p className={cn("fixed-rewards", { [inline]: inline !== "none" })}>
      {children}
    </p>
  );
};

export const TaxesAndFeesText = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const styles = useUiStyles(CoreUiComponents.PriceDisplay, defaultStyles);
  const [, cn] = useModuleBEM(styles, CoreUiComponents.PriceDisplay);

  return <span className={cn("taxes-and-fees")}>{children}</span>;
};

export const PriceText = ({
  children,
  priceOnly = false,
}: {
  children?: React.ReactNode;
  priceOnly?: boolean;
}) => {
  const styles = useUiStyles(CoreUiComponents.PriceDisplay, defaultStyles);
  const [, cn] = useModuleBEM(styles, CoreUiComponents.PriceDisplay);

  return <span className={cn("price", { priceOnly })}>{children}</span>;
};
